<template>
	<TwoColumns
		columns-order="flex-col lg:flex-row"
		first-column-class="bg-white contained-section"
		second-column-class="bg-white contained-section"
	>
		<template #first>
			<CarbarImage
				image="img/car-subscription/img-price-match.webp"
				alt-text="Price match guarantee"
			/>
		</template>
		<template #second>
			<div class="flex w-full flex-col">
				<h2>Price match guarantee</h2>
				<div class="flex flex-col gap-4">
					<div>
						<h3 class="font-body font-medium">
							Find a lower price? We'll match it!
							<br class="hidden md:block" />
							Shop with confidence–we've got you covered!
						</h3>
					</div>
					<p>
						If you find an identical vehicle at a better price from
						a direct competitor, we'll match it.
					</p>
				</div>
				<TickList
					:items="priceMatchItems"
					class="text-lg lg:space-y-1"
				/>
			</div>
			<div class="mt-8 flex w-full flex-col gap-4">
				<h3 class="font-body font-medium">
					How to claim the price match guarantee:
				</h3>
				<div
					class="grid w-full grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2"
				>
					<div>
						<div class="mb-1 font-medium text-gray-700">
							Step 1:
						</div>
						<div class="text-lg">
							Email us at
							<CarbarLink
								text-color="text-gray-575"
								href="mailto:subscriptions@carbar.com.au"
								text="subscriptions@carbar.com.au"
							/>
							before your car subscription application is
							approved.
						</div>
					</div>
					<div>
						<div class="mb-1 font-medium text-gray-700">
							Step 2:
						</div>
						<div class="text-lg">
							Provide evidence of the competitor's lower
							subscription fee (including GST and delivery
							charges) for the same vehicle make, model,
							grade/variant, and year.
						</div>
					</div>
					<div>
						<div class="mb-1 font-medium text-gray-700">
							Step 3:
						</div>
						<div class="text-lg">
							Submit supporting documents such as timestamped
							screenshots or relevant links to the competitor's
							website.
						</div>
					</div>
					<div>
						<div class="mb-1 font-medium text-gray-700">
							Step 4:
						</div>
						<div class="text-lg">
							We will confirm in writing whether your price match
							guarantee claim has been successfully applied to
							your selected vehicle.
						</div>
					</div>
				</div>
			</div>
		</template>
	</TwoColumns>
</template>

<script setup>
import TwoColumns from '@/components/sections/TwoColumns.vue'
import TickList from '@/components/lists/TickList.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import CarbarImage from '@/components/CarbarImage.vue'

const priceMatchItems = [
	{
		label: 'Must be the same make, model, variant, and year.',
	},
	{
		label: 'Have not held a carbar subscription in the 12 months preceding your customer application.',
	},
	{
		label: 'Excludes clearance sales or inventory reductions due to stock liquidation.',
	},
]
</script>
